(function () {
    'use strict';

    angular.module("imApp").factory("sirvSetupService", ['$ihttp', function ($ihttp) {
        var service = {
            getSirvSetup: function (parms) {
                return $ihttp.post({
                    method: 2470,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2471,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();